import VideoBackgroundSlider from './VideoBackgroundSlider';

export default VideoBackgroundSlider;



// WEBPACK FOOTER //
// ./src/client/js/view/components/VideoBackgroundSlider/index.js